 import  './Footer.css'


export const Footer = () =>{
  return (
    <footer>
      <p>© Charlotte Norford 2026: Robot Job Board Application </p>
    </footer>
  );
};

export default Footer;
